// Generated by purs version 0.15.0
import * as $foreign from "./foreign.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Array from "../Data.Array/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Effect_Ref from "../Effect.Ref/index.js";
import * as Effect_Uncurried from "../Effect.Uncurried/index.js";
import * as Foreign_Object from "../Foreign.Object/index.js";
import * as Specular_Dom_Browser from "../Specular.Dom.Browser/index.js";
import * as Specular_Dom_Builder from "../Specular.Dom.Builder/index.js";
import * as Specular_Dom_Builder_Class from "../Specular.Dom.Builder.Class/index.js";
import * as Specular_Dom_Widgets_Input from "../Specular.Dom.Widgets.Input/index.js";
import * as Specular_FRP_Base from "../Specular.FRP.Base/index.js";
import * as Specular_Internal_Effect from "../Specular.Internal.Effect/index.js";
import * as Specular_Internal_Profiling from "../Specular.Internal.Profiling/index.js";
import * as Specular_Profiling from "../Specular.Profiling/index.js";
var Prop = function (x) {
    return x;
};
var unsafeEventTarget = function (e) {
    return e.target;
};
var withTargetChecked = function (cb) {
    return function (event) {
        return function __do() {
            var value = Specular_Dom_Widgets_Input.getCheckboxChecked(unsafeEventTarget(event))();
            return cb(value)();
        };
    };
};
var withTargetValue = function (cb) {
    return function (event) {
        return function __do() {
            var value = Specular_Dom_Widgets_Input.getTextInputValue(unsafeEventTarget(event))();
            return cb(value)();
        };
    };
};
var text = function (str) {
    return Specular_Dom_Builder["mkBuilder$prime"](function (env) {
        var node = Specular_Dom_Browser.createTextNode(str)();
        return Specular_Dom_Browser.appendChild(node)(env.parent)();
    });
};
var stopPropagation = /* #__PURE__ */ Effect_Uncurried.runEffectFn1($foreign["_stopPropagation"]);
var semigroupProp = {
    append: function (v) {
        return function (v1) {
            return function (node, cleanups) {
                v(node, cleanups);
                return v1(node, cleanups);
            };
        };
    }
};
var preventDefault = Specular_Dom_Browser.preventDefault;
var on = function (eventType) {
    return function (cb) {
        return function (node, _cleanups) {
            Specular_Dom_Browser.addEventListener(eventType)(function (e) {
                return Specular_Profiling.measure(Effect_Class.monadEffectEffect)("event: " + eventType)(cb(e));
            })(node)();
            return Data_Unit.unit;
        };
    };
};
var onClick = function (cb) {
    return on("click")(cb);
};
var onClick_ = function (cb) {
    return onClick(function (v) {
        return cb;
    });
};
var monoidProp = {
    mempty: function (v, v1) {
        return Data_Unit.unit;
    },
    Semigroup0: function () {
        return semigroupProp;
    }
};
var initElement = function (env, node, props, body) {
    var mark = Specular_Internal_Profiling.begin("el");
    var result = Specular_Dom_Builder["runBuilder$prime"]({
        parent: node,
        cleanup: env.cleanup,
        userEnv: env.userEnv
    }, body);
    Effect.foreachE(props)(function (v) {
        return function () {
            return v(node, env.cleanup);
        };
    })();
    Specular_Dom_Browser.appendChild(node)(env.parent)();
    Specular_Internal_Profiling.end(mark);
    return result;
};
var el$prime = function (tagName) {
    return function (props) {
        return function (body) {
            return Specular_Dom_Builder["mkBuilder$prime"](function (env) {
                var node = Specular_Dom_Browser.createElement(tagName)();
                var result = initElement(env, node, props, body);
                return new Data_Tuple.Tuple(node, result);
            });
        };
    };
};
var el = function (tagName) {
    return function (props) {
        return function (body) {
            return Specular_Dom_Builder["mkBuilder$prime"](function (env) {
                var node = Specular_Dom_Browser.createElement(tagName)();
                return initElement(env, node, props, body);
            });
        };
    };
};
var el_ = function (tagName) {
    return el(tagName)(Data_Monoid.mempty(Data_Monoid.monoidArray));
};
var dynText = function (strD) {
    return Control_Bind.bind(Specular_Dom_Builder.bindBuilder)(Specular_Dom_Builder["mkBuilder$prime"](function (env) {
        var node = Specular_Dom_Browser.createTextNode("")();
        Specular_Dom_Browser.appendChild(node)(env.parent)();
        return node;
    }))(function (node) {
        return Specular_FRP_Base.subscribeDyn_(Specular_FRP_Base.monadFRP(Specular_Dom_Builder.monadEffectBuilder)(Specular_Dom_Builder.monadCleanupBuilder))(Specular_Dom_Browser.setText(node))(strD);
    });
};
var classes = function (clss) {
    return function (node, v) {
        return Effect.foreachE(clss)(function (cls) {
            return function () {
                return $foreign["_addClass"](node, cls);
            };
        })();
    };
};
var class_ = function (cls) {
    return function (node, v) {
        return $foreign["_addClass"](node, cls);
    };
};
var classWhen = function (enabled) {
    return function (cls) {
        if (enabled) {
            return class_(cls);
        };
        return Data_Monoid.mempty(monoidProp);
    };
};
var classUnless = function (enabled) {
    return function (cls) {
        if (enabled) {
            return Data_Monoid.mempty(monoidProp);
        };
        return class_(cls);
    };
};
var attrs = function (a) {
    return function (node, v) {
        return Specular_Dom_Browser.setAttributes(node)(a)();
    };
};
var attrsUnless = function (v) {
    if (!v) {
        return attrs;
    };
    if (v) {
        return Data_Monoid.mempty(Data_Monoid.monoidFn(monoidProp));
    };
    throw new Error("Failed pattern match at Specular.Dom.Element (line 179, column 1 - line 179, column 40): " + [ v.constructor.name ]);
};
var attrsWhen = function (v) {
    if (v) {
        return attrs;
    };
    if (!v) {
        return Data_Monoid.mempty(Data_Monoid.monoidFn(monoidProp));
    };
    throw new Error("Failed pattern match at Specular.Dom.Element (line 175, column 1 - line 175, column 38): " + [ v.constructor.name ]);
};
var attr = function (name) {
    return function (value) {
        return attrs(Foreign_Object.singleton(name)(value));
    };
};
var attrUnless = function (v) {
    return function (v1) {
        return function (v2) {
            if (!v) {
                return attr(v1)(v2);
            };
            if (v) {
                return Data_Monoid.mempty(monoidProp);
            };
            throw new Error("Failed pattern match at Specular.Dom.Element (line 171, column 1 - line 171, column 55): " + [ v.constructor.name, v1.constructor.name, v2.constructor.name ]);
        };
    };
};
var attrWhen = function (v) {
    return function (v1) {
        return function (v2) {
            if (v) {
                return attr(v1)(v2);
            };
            if (!v) {
                return Data_Monoid.mempty(monoidProp);
            };
            throw new Error("Failed pattern match at Specular.Dom.Element (line 167, column 1 - line 167, column 53): " + [ v.constructor.name, v1.constructor.name, v2.constructor.name ]);
        };
    };
};
var _subscribeDyn = function (cleanups, dyn, handler) {
    var unsub = Specular_FRP_Base["_subscribeEvent"](Effect_Uncurried.runEffectFn1(handler), Specular_FRP_Base.changed(dyn));
    Specular_Internal_Effect.pushDelayed(cleanups)(unsub)();
    var initialValue = Specular_FRP_Base.readDynamic(Effect_Class.monadEffectEffect)(dyn)();
    return handler(initialValue);
};
var attrsD = function (dynAttrs) {
    return function (node, cleanups) {
        var attrsRef = Effect_Ref["new"](Foreign_Object.empty)();
        var resetAttributes = function (newAttrs) {
            var oldAttrs = Effect_Ref.read(attrsRef)();
            Effect_Ref.write(newAttrs)(attrsRef)();
            var removed = Data_Array.filter(function (k) {
                return !Foreign_Object.member(k)(newAttrs);
            })(Foreign_Object.keys(oldAttrs));
            var changed = Foreign_Object.filterWithKey(function (k) {
                return function (v) {
                    return Data_Eq.notEq(Data_Maybe.eqMaybe(Data_Eq.eqString))(Foreign_Object.lookup(k)(oldAttrs))(new Data_Maybe.Just(v));
                };
            })(newAttrs);
            Specular_Dom_Browser.removeAttributes(node)(removed)();
            return Specular_Dom_Browser.setAttributes(node)(changed)();
        };
        return _subscribeDyn(cleanups, dynAttrs, resetAttributes);
    };
};
var attrD = function (name) {
    return function (valD) {
        return attrsD(Data_Functor.mapFlipped(Specular_FRP_Base.functorDynamic)(valD)(function (v) {
            return Foreign_Object.singleton(name)(v);
        }));
    };
};
var attrUnlessD = function (conditionD) {
    return function (name) {
        return function (value) {
            return attrsD(Data_Functor.mapFlipped(Specular_FRP_Base.functorDynamic)(conditionD)(function (v) {
                if (v) {
                    return Data_Monoid.mempty(Foreign_Object.monoidObject(Data_Semigroup.semigroupString));
                };
                return Foreign_Object.singleton(name)(value);
            }));
        };
    };
};
var attrWhenD = function (conditionD) {
    return function (name) {
        return function (value) {
            return attrsD(Data_Functor.mapFlipped(Specular_FRP_Base.functorDynamic)(conditionD)(function (v) {
                if (v) {
                    return Foreign_Object.singleton(name)(value);
                };
                return Data_Monoid.mempty(Foreign_Object.monoidObject(Data_Semigroup.semigroupString));
            }));
        };
    };
};
var attrsUnlessD = function (conditionD) {
    return function (attrs$prime) {
        return attrsD(Data_Functor.mapFlipped(Specular_FRP_Base.functorDynamic)(conditionD)(function (v) {
            if (v) {
                return Data_Monoid.mempty(Foreign_Object.monoidObject(Data_Semigroup.semigroupString));
            };
            return attrs$prime;
        }));
    };
};
var attrsWhenD = function (conditionD) {
    return function (attrs$prime) {
        return attrsD(Data_Functor.mapFlipped(Specular_FRP_Base.functorDynamic)(conditionD)(function (v) {
            if (v) {
                return attrs$prime;
            };
            return Data_Monoid.mempty(Foreign_Object.monoidObject(Data_Semigroup.semigroupString));
        }));
    };
};
var classesD = function (clssD) {
    return function (node, cleanups) {
        var updateClasses = $foreign["_initClasses"](node);
        return _subscribeDyn(cleanups, clssD, updateClasses);
    };
};
var classUnlessD = function (enabled) {
    return function (cls) {
        return classesD(Data_Functor.mapFlipped(Specular_FRP_Base.functorDynamic)(enabled)(function (v) {
            if (v) {
                return [  ];
            };
            return [ cls ];
        }));
    };
};
var classWhenD = function (enabled) {
    return function (cls) {
        return classesD(Data_Functor.mapFlipped(Specular_FRP_Base.functorDynamic)(enabled)(function (v) {
            if (v) {
                return [ cls ];
            };
            return [  ];
        }));
    };
};
var propertyD = function (property) {
    return function (dyn) {
        return function (node, cleanups) {
            return _subscribeDyn(cleanups, dyn, function (v) {
                return $foreign.setProperty(node, property, v);
            });
        };
    };
};
var checkedD = /* #__PURE__ */ propertyD("checked");
var bindChecked = function (v) {
    return Data_Semigroup.append(semigroupProp)(checkedD(v.value0))(on("change")(withTargetChecked(function ($56) {
        return v.value1(Data_Function["const"]($56));
    })));
};
var indeterminateD = /* #__PURE__ */ propertyD("indeterminate");
var valueD = /* #__PURE__ */ propertyD("value");
var bindValueOnChange = function (v) {
    return Data_Semigroup.append(semigroupProp)(valueD(v.value0))(on("change")(withTargetValue(function ($57) {
        return v.value1(Data_Function["const"]($57));
    })));
};
var bindValueOnInput = function (v) {
    return Data_Semigroup.append(semigroupProp)(valueD(v.value0))(on("input")(withTargetValue(function ($58) {
        return v.value1(Data_Function["const"]($58));
    })));
};
export {
    el$prime,
    el,
    el_,
    Prop,
    text,
    dynText,
    attr,
    attrD,
    attrWhen,
    attrUnless,
    attrWhenD,
    attrUnlessD,
    attrs,
    attrsD,
    attrsWhen,
    attrsUnless,
    attrsWhenD,
    attrsUnlessD,
    on,
    onClick,
    onClick_,
    preventDefault,
    stopPropagation,
    valueD,
    bindValueOnChange,
    bindValueOnInput,
    checkedD,
    bindChecked,
    indeterminateD,
    class_,
    classes,
    classesD,
    classWhenD,
    classUnlessD,
    classWhen,
    classUnless,
    semigroupProp,
    monoidProp
};
export {
    rawHtml
} from "../Specular.Dom.Builder.Class/index.js";
//# sourceMappingURL=index.js.map
